import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import simpleApi from 'app/services/simpleApi'

import longTermLeaseInvoiceRequests from '../LongTermLeaseInvoice.requests'

const useSendLongTermLeaseInvoiceToSap = ({
    onSuccess,
}: {
    onSuccess: () => void,
}) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    } = useHandleStatusRequest({
        id: 'sendLongTermLeaseInvoiceToSap',
        title: 'Send To Sap',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            longTermLeaseInvoiceId,
        }: {
            longTermLeaseInvoiceId: number,
        }) => {
            return simpleApi({
                ...longTermLeaseInvoiceRequests.sapSending({
                    longTermLeaseInvoiceId,
                }),
                token,
            })
        },
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    })
}

export default useSendLongTermLeaseInvoiceToSap
